import React from 'react'
import { PopupBody, PopupBodySubHeadline } from './PopupBase'

type Props = {
  fontResizeRate: number;
}

const PopupKugu: React.FC<Props> = ({ fontResizeRate }) => {
  return (
    <div>
      <PopupBody fontResizeRate={fontResizeRate}>
        外構・造園・建築・不動産を軸に、よりよい空間をつくる株式会社kuguのロゴマークを制作しました。
        <br /><br />
        たとえば「k」は直線・ななめ・カーブから構成されており（画像2枚目参照）そのような異なる形から成り立つ、ほんのりと個性のある一文字ひと文字の連なりは、「kugu」としてまとまり調和しています。これはkuguの目指す「呼吸する空間」に通じています。同じ文字でも形の異なる2つの「u」はkuguが見つめる時代や今目の前の「変化」と、それを踏まえてより良く生み出していく「変化」を示しています。「g」から「u」に連なり呼吸するような有機的で柔らかい曲線は、kuguの根本にある柔軟さと柔軟でいようとする意志の象徴です。そして空間に立ち入る際の、境界をくぐりぬけるニュアンスを含んでいます。kuguだけに。
        <br /><br />
        普段のお仕事で意識されているテーマ「呼吸する空間・育つ場所・季節を纏う場所」を中心に、kuguの大切のしている視点や目の前の空間に向き合う姿勢から生まれたデザインです。
      </PopupBody>
    </div>
  )
}

export default PopupKugu